import { LOAD_MU4_ACCESS_GROUPS_REQUEST, LOAD_MU4_ACCESS_GROUPS_SUCCESS, LOAD_MU4_ACCESS_GROUPS_FAIL } from 'src/store/actions/mu4Actions';
const initialState = {
    accessGroups: [],
    accessGroupsFetching: false
};
const mu4Reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_MU4_ACCESS_GROUPS_REQUEST:
            return { ...state, accessGroupsFetching: true };
        case LOAD_MU4_ACCESS_GROUPS_SUCCESS:
            return { ...state, accessGroups: action.accessGroups || [], accessGroupsFetching: false };
        case LOAD_MU4_ACCESS_GROUPS_FAIL:
            return { ...state, accessGroupsFetching: false };
        default:
            return state;
    }
};
export default mu4Reducer;
